import { Document, Page, View, Text } from '@react-pdf/renderer'
import { formatDateTSX } from '../../../utils/tsxFormat'
import { styles } from './styles'

const deliveryStatus = {
  in_loading: 'Em carregamento',
  loaded: 'Carregada',
  started: 'Iniciada',
  finished: 'Finalizada',
}

const requestStatus = {
  unallocated: 'Não alocada',
  allocated: 'Alocada',
  in_progress: 'Em andamento',
  on_route: 'Em rota',
  delivered: 'Entregue',
  canceled: 'Cancelada',
}

const DeliverySummary = ({ delivery, requests, vehicle }) => {
  const getCompleteAddress = (request) => {
    return `${request.street}, ${request.street_number} - ${
      request.neighborhood
    }, ${request.city} - ${request.state}, ${request.cep}. ${
      request.complement ? `Complemento: ${request.complement}` : ''
    }`
  }

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* Cabeçalho do Relatório */}
        <View>
          <Text style={{ fontSize: 20 }}>Resumo de carga - Nº {delivery.id}</Text>
          <Text style={{ fontSize: 10, marginBottom: 10 }}>
            Data de emissão: {formatDateTSX(new Date(), "dd/MM/yyyy 'às' HH:mm:ss")}
          </Text>
          <Text style={{ fontSize: 11 }}>
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>Status: </Text>
            {deliveryStatus[delivery.status]}
          </Text>
          <Text style={{ fontSize: 11 }}>
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>Peso total alocado: </Text>
            {delivery.allocated_weight} kg, divididos em {requests.length} requisições de entrega
          </Text>
          <Text style={{ fontSize: 11 }}>
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>Sobre o veículo: </Text>
            {vehicle.model} | Placa {vehicle.board}
          </Text>
          <Text style={{ fontSize: 11 }}>
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>Motorista: </Text>
            {vehicle.name || 'Ainda desconhecido'}
          </Text>
        </View>

        {/* Cabeçalho da Tabela */}
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <View style={styles.col1_5}>
              <Text style={[styles.tableCell]}>Nº NF</Text>
            </View>
            <View style={styles.col1_5}>
              <Text style={[styles.tableCell]}>Nº Pedido</Text>
            </View>
            <View style={styles.col3}>
              <Text style={[styles.tableCell]}>Endereço completo</Text>
            </View>
            <View style={styles.col2}>
              <Text style={styles.tableCell}>Nome cliente</Text>
            </View>
            <View style={styles.col1}>
              <Text style={styles.tableCell}>Peso total (kg)</Text>
            </View>
            <View style={styles.col1}>
              <Text style={styles.tableCell}>Status</Text>
            </View>
            <View style={styles.col2}>
              <Text style={styles.tableCellLast}>Observações</Text>
            </View>
          </View>

          {requests?.length > 0 ? (
            <>
              {requests.map((request, index) => (
                <View style={index % 2 === 0 ? styles.tableRow : styles.tableRowOdd} key={index}>
                  <View style={styles.col1_5}>
                    <Text style={styles.tableCell}>
                      {request.invoice_number ?? `${request.invoice.substring(0, 10)}...`}
                    </Text>
                  </View>
                  <View style={styles.col1_5}>
                    <Text style={styles.tableCell}>{request.request_number || '-'}</Text>
                  </View>
                  <View style={styles.col3}>
                    <Text style={styles.tableCell}>{getCompleteAddress(request)}</Text>
                  </View>
                  <View style={styles.col2}>
                    <Text style={styles.tableCell}>{request.receiver_name}</Text>
                  </View>
                  <View style={styles.col1}>
                    <Text style={styles.tableCell}>{request.weight}</Text>
                  </View>
                  <View style={styles.col1}>
                    <Text style={styles.tableCell}>{requestStatus[request.status]}</Text>
                  </View>
                  <View style={styles.col2}>
                    <Text style={styles.tableCellLast}>{request.note}</Text>
                  </View>
                </View>
              ))}
            </>
          ) : (
            <Text>Não há pedidos para exibir</Text>
          )}
        </View>
      </Page>
    </Document>
  )
}

export default DeliverySummary
